/* ---------------------------------------------------------------------
   Mamavea - colour swatch gap filler
   Data comes from snippets/mamavea-swatch-data.liquid

   The product template's inline swatch script skips any colour whose name
   is a substring of an earlier colour name (Brown after Dark Brown, White
   after Black/White, Blue after Navy Blue). Those swatches end up as bare
   text boxes in a row of image tiles.

   This script fills in only the swatches that are missing their image. It
   never touches a swatch that is already correct, so it is idempotent and
   safe to re-run - which matters, because the original script re-runs on a
   timer and on every variant change.

   Quick-view modals are deliberately skipped: the map in the head belongs
   to the product whose page is open, and applying it inside a modal for a
   different product would show the wrong photo.
--------------------------------------------------------------------- */

(function () {
  'use strict';

  var MODAL_SELECTOR = '.modal, .quick-shop-modal, [data-quick-shop], .predictive-search';

  function normalise(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  /* The main product block, never one inside a quick-view modal. */
  function mainProductScope() {
    var candidates = document.querySelectorAll('.product-single__meta, .product-section');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el.closest || !el.closest(MODAL_SELECTOR)) return el;
    }
    return null;
  }

  function lookup(map, value) {
    if (map[value]) return map[value];
    var target = normalise(value);
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
      if (normalise(keys[i]) === target) return map[keys[i]];
    }
    return null;
  }

  function fillGaps() {
    var map = window.mamaveaSwatchImages;
    if (!map) return;

    var root = mainProductScope();
    if (!root) return;

    var wrappers = root.querySelectorAll('.variant-wrapper');
    if (!wrappers.length) return;

    var labels = wrappers[0].querySelectorAll('.variant-input-wrap label');

    Array.prototype.forEach.call(labels, function (label) {
      var input = document.getElementById(label.getAttribute('for'));
      var value = '';
      if (input) value = input.getAttribute('value') || input.value || '';
      if (!value) value = label.getAttribute('data-value') || label.getAttribute('title') || label.textContent || '';
      value = String(value).trim();
      if (!value) return;

      var url = lookup(map, value);
      if (!url) return;

      /* Already showing the right image - leave it alone. */
      var current = label.style.backgroundImage || '';
      if (current.indexOf(url) !== -1) return;

      label.style.backgroundImage = 'url("' + url + '")';
      label.classList.remove('no-image');
      if (label.textContent) label.textContent = '';
    });
  }

  var pending = null;
  function schedule() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      fillGaps();
    }, 60);
  }

  function watch() {
    var root = mainProductScope();
    if (!root || root.getAttribute('data-mamavea-swatch-watch') === 'on') return;
    if (typeof MutationObserver !== 'function') return;
    root.setAttribute('data-mamavea-swatch-watch', 'on');
    new MutationObserver(schedule).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  function start() {
    fillGaps();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);

  /* The original script runs at 300ms, 1s and 2s - land just after each. */
  setTimeout(start, 400);
  setTimeout(start, 1100);
  setTimeout(start, 2100);
})();
